<script lang="ts">
    import CN from "classnames";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    export let ariaLabel: string;
    export let disabled = false;
</script>

<BaseButton
    on:click
    {ariaLabel}
    class={CN("gw-post-modal-btn", {
        "gw-post-modal-btn--disable": disabled,
    })}
    {disabled}
>
    <slot />
</BaseButton>

<style lang="postcss" global>
    .gw-btn.gw-post-modal-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: inherit;
        padding: 4px 13px;
        column-gap: 10px;
        border-radius: 5px;
        background-color: var(--gw-post-modal-button-bg);
        color: var(--gw-post-modal-button-text-color);
        font-size: 1em;
        font-weight: 500;
        text-transform: uppercase;

        &:hover {
            background-color: var(--gw-post-modal-button-hover-bg);
            color: var(--gw-post-modal-button-hover-text-color);
        }

        &--disable,
        &--disable:hover {
            opacity: 0.7;
            background-color: #8b8d8f;
            color: #fff;
            cursor: not-allowed;
        }
    }

    @media all and (max-width: 768px) and (min-width: 425px) {
        .gw-post-modal-btn {
            max-width: 320px;
        }
    }
</style>
